angular.module('assets')
    .component('assetListComponent', {
        bindings: {
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/asset/_table.html',
        controller: function ($scope, $state, $stateParams, AssetService) {
            this.reset = () => this.filters = {}
            this.AssetService = AssetService;

            $scope.$on('asset.updated', () => $state.reload());
        }
    })
